export default __webpack_public_path__ + "static/media/backcolor.3ab9f981.svg";